/* eslint-disable camelcase */
export const handleAppointmentClick = (e: React.MouseEvent, name: string) => {
	e.preventDefault();
	const target = e.target as HTMLAnchorElement;
	const link = target?.href;

	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		event: 'finda',
		event_action: `request_appt_button_clicked`,
		location_name: name,
	});

	if (link) {
		window.location.href = link;
	}

	return false;
};
